export default [
  {
    path: '/monedero/resumen',
    name: 'WalletSummaryAdmin',
    component: () => import('@/views/wallet/WalletAdminSummary.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/monedero/:customerId',
    name: 'WalletForCustomer',
    component: () => import('@/views/wallet/WalletForCustomer.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
